var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8.38849L5.75 2.91016",
    stroke: "#5BD2B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.3528V6.90832C19.9996 6.53811 19.9019 6.17451 19.7166 5.85399C19.5314 5.53347 19.2651 5.26731 18.9444 5.08221L11.5556 0.859984C11.2346 0.674695 10.8706 0.577148 10.5 0.577148C10.1294 0.577148 9.76537 0.674695 9.44444 0.859984L2.05556 5.08221C1.73494 5.26731 1.46865 5.53347 1.28338 5.85399C1.09811 6.17451 1.00038 6.53811 1 6.90832V15.3528C1.00038 15.723 1.09811 16.0866 1.28338 16.4071C1.46865 16.7276 1.73494 16.9938 2.05556 17.1789L9.44444 21.4011C9.76537 21.5864 10.1294 21.6839 10.5 21.6839C10.8706 21.6839 11.2346 21.5864 11.5556 21.4011L18.9444 17.1789C19.2651 16.9938 19.5314 16.7276 19.7166 16.4071C19.9019 16.0866 19.9996 15.723 20 15.3528Z",
    stroke: "#5BD2B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2832 5.81152L10.4982 11.1421L19.7132 5.81152",
    stroke: "#5BD2B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.4436V11.1299",
    stroke: "#5BD2B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.d346d90aa640d15258715547f72ed1d3.svg";
export { ForwardRef as ReactComponent };